import axiosService from '../../services/axios/axios.service';
import { CreateUserInterface, UserInterface, UserUpdateInterface } from '@/models/user.model';
export interface GetUsersParams {
    page?: number;
    limit?: number;
    search?: string;
    sort?: string;
    order?: string;
    deactivated?: boolean;
    isWorking?: string;
    role?: string;
    notInProject?: string;
}

export const getUsers = async (
    params: GetUsersParams
): Promise<
    NonNullable<{
        users: UserInterface[];
        total: number;
        page: number;
        limit: number;
    }>
> => {
    const response = await axiosService.get('/user/get-users', { params });
    return response.data;
};

export const updateUser = async (payload: UserUpdateInterface) => {
    const response = await axiosService.patch('/user/update-user', payload);
    return response.data;
};

export const getUsersNotInProject = async (
    id?: string
): Promise<NonNullable<UserInterface[]>> => {
    if (!id) {
        return [];
    }
    const response = await axiosService.get(
        `/user/get-users-not-in-project/${id}`
    );
    return response.data;
};

export const createUser = async (
    payload: CreateUserInterface
): Promise<NonNullable<any>> => {
    const response = await axiosService.post('/user/create-user', payload);
    return response.data;
};
